import { render, staticRenderFns } from "./ForgotUsernameSuccess.vue?vue&type=template&id=7034b1c2&scoped=true&"
import script from "./ForgotUsernameSuccess.vue?vue&type=script&lang=js&"
export * from "./ForgotUsernameSuccess.vue?vue&type=script&lang=js&"
import style0 from "./ForgotUsernameSuccess.vue?vue&type=style&index=0&id=7034b1c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7034b1c2",
  null
  
)

export default component.exports